import { render, staticRenderFns } from "./BorderEditor.vue?vue&type=template&id=96793e58&scoped=true"
import script from "./BorderEditor.vue?vue&type=script&lang=js"
export * from "./BorderEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96793e58",
  null
  
)

export default component.exports